import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["startDate", "endDate", "timezone"];

  connect() {
    this.setupDateConstraints();
    this.autoDetectTimezone();
  }

  setupDateConstraints() {
    if (this.hasStartDateTarget && this.hasEndDateTarget) {
      // Set initial min date to today
      const today = new Date().toISOString().split("T")[0];
      this.startDateTarget.min = today;
      this.endDateTarget.min = today;

      // Update end date min when start date changes
      this.updateEndDateMin();
    }
  }

  startDateChanged() {
    this.updateEndDateMin();
  }

  updateEndDateMin() {
    const startDate = this.startDateTarget.value;

    if (startDate) {
      this.endDateTarget.min = startDate;

      // If end date is before start date, update it
      if (this.endDateTarget.value && this.endDateTarget.value < startDate) {
        this.endDateTarget.value = startDate;
      }
    }
  }

  autoDetectTimezone() {
    if (this.hasTimezoneTarget && !this.timezoneTarget.value) {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const option = this.timezoneTarget.querySelector(`option[value="${userTimezone}"]`);

      if (option) {
        this.timezoneTarget.value = userTimezone;
      }
    }
  }
}
